module.exports = __webpack_public_path__ + "img/d889b94d2aed709915a477001bc1d489.96a0a46e.png";